import api from '@pray/shared/utils/api';

/**
 * Delete a tag (soft delete).
 *
 * @param {object} params
 * @param {string} params.tagId - The ID of the tag to delete
 */
export async function deleteTag({ tagId }) {
  if (!tagId) throw Error('Tag ID is required');

  const url = `/web/studio/tags/${tagId}`;
  const response = await api.executeDeleteRequest(url);

  return response.data;
}
